import RadioList from 'common/components/RadioList';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import React from 'react';

interface Fields {
    profileApproval: boolean;
}

interface Props<T> {
    form: ObservableForm<T>;
}

const ProfileApprovalField: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
}) => {
    return (
        <Field
            form={form}
            name="profileApproval"
            title={__(
                'Can your designer showcase the finished designs in their 99designs portfolio?'
            )}
            render={() => (
                <RadioList
                    options={[
                        {
                            value: 'yes',
                            label: __('Yes'),
                        },
                        {
                            value: 'no',
                            label: __('No'),
                        },
                    ]}
                    // This is manually configured instead of using `form.attach` because the field value is
                    // a boolean, where RadioList only accepts string values, so we need to convert between.
                    name="profileApproval"
                    value={form.get('profileApproval') ? 'yes' : 'no'}
                    onChange={(value: string) => form.set('profileApproval', value == 'yes')}
                />
            )}
        />
    );
};

export default ProfileApprovalField;
